import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmartyModule } from '@modules/smarty.module';
import { ValidatorsModule } from '@modules/validators/validators.module';
import { RegistrationComponent } from './registration.component';
import { RegistrationService } from './services/registration.service';
import { SisValidationSummaryComponent } from '@smartera/components';

const loginRoutes: Routes = [
	{
		path: 'registration',
		component: RegistrationComponent,
	},
];

@NgModule({
	imports: [SmartyModule, RouterModule.forChild(loginRoutes), ValidatorsModule, SisValidationSummaryComponent],
	declarations: [RegistrationComponent],
	exports: [RegistrationComponent],

	providers: [RegistrationService],
})
export class RegistrationModule {}
